module.exports = __webpack_public_path__ + "static/media/red-red.9a7cbf0f.png";